"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Table = _interopRequireDefault(require("../Table.context"));

var _TableRow = require("./TableRow.styles");

var _excluded = ["onClick", "children", "innerRef"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TableRow = function TableRow(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      innerRef = _ref.innerRef,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var context = (0, _react.useContext)(_Table["default"]);
  var type = context.type;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement(_TableRow.StyledTableRow, (0, _extends2["default"])({
      onClick: onClick,
      ref: innerRef,
      type: type
    }, props), children)
  );
};

TableRow.defaultProps = {
  onClick: function onClick() {
    return null;
  },
  innerRef: function innerRef() {
    return null;
  }
};
TableRow.propTypes = {
  /** Children of the row (TableCell or TableHeaderCell) */
  children: _propTypes.node.isRequired,

  /** Function to be called if the row is clicked */
  onClick: _propTypes.func,

  /** InnerRef, ref forwarding */
  innerRef: _propTypes.func
};
TableRow.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableRow",
  "props": {
    "onClick": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "Function to be called if the row is clicked",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "innerRef": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "InnerRef, ref forwarding",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "children": {
      "description": "Children of the row (TableCell or TableHeaderCell)",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(TableRow);

exports["default"] = _default;